import { useLayoutEffect, useState } from "react";

export const useElementWidth = <T extends HTMLElement>(): [(element: T | null) => void, number] => {
  const [element, setElement] = useState<T | null>(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!element) {
      return;
    }

    const updateWidth = (measuredWidth: number) => setWidth(Math.round(measuredWidth));

    updateWidth(element.getBoundingClientRect().width);

    const resizeObserver = new ResizeObserver(([entry]) => updateWidth(entry.contentRect.width));

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [element]);

  return [setElement, width];
};
